module.exports = __webpack_public_path__ + "img/navigationalAidsOther.3730e92f.svg";